import React from "react";
import { cn } from "@/utils/css";

export const Button = ({ onClick, type = "button", children, disabled }) => {
    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={cn(
                "w-full h-full min-h-12 inline-flex items-center justify-center rounded-lg text-cm-p-neutral-dark-500 font-semibold",
                {
                    "bg-cm-p-accent-500 opacity-50": disabled,
                    "bg-cm-p-accent": !disabled,
                },
            )}
        >
            {children}
        </button>
    );
};
